import { useState } from 'react';
import SectionHeading from './SectionHeading';
import { events, eventTypes } from '@/mocks/mikami/events';

export default function EventsSection() {
  const [active, setActive] = useState('all');
  const list = active === 'all' ? events : events.filter((event) => event.type === active);

  return (
    <section id="events" className="anchor-offset bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-8">
        <SectionHeading
          eyebrow="活动日历"
          title="活动方向与参与方式"
          description="活动区把线下活动、线上直播、合作联动与粉丝活动分类归档。这里说明的是参与方式方向与注意事项，具体时间、地点与报名细则请以主办方公布为准。"
        />

        <div className="mb-6 flex flex-wrap gap-2 rounded-full border border-background-200 bg-background-100 px-2 py-2">
          {eventTypes.map((type) => {
            const isActive = type.id === active;
            return (
              <button
                key={type.id}
                type="button"
                onClick={() => setActive(type.id)}
                aria-pressed={isActive}
                className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-label transition-colors ${
                  isActive
                    ? 'bg-secondary-500 text-background-50'
                    : 'text-foreground-700 hover:bg-secondary-100 hover:text-secondary-900'
                }`}
              >
                {type.label}
              </button>
            );
          })}
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          {list.map((event) => (
            <article key={event.id} className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
              <div className="flex flex-wrap items-center gap-2">
                <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-label text-accent-800">
                  <i className="ri-calendar-line"></i>
                  {event.typeLabel}
                </span>
                <span className="text-xs text-foreground-500">{event.period}</span>
              </div>
              <h3 className="mt-3 font-heading text-base font-bold text-foreground-950 md:text-lg">{event.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{event.summary}</p>
              <p className="mt-4 flex items-center gap-1.5 border-t border-background-200 pt-3 text-xs text-foreground-500">
                <i className="ri-ticket-2-line"></i>
                {event.meta}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}